import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { IrisTimelineEventType } from '@app/core/types/iris-report';

export interface IrisTimelineStyleConfig {
  icon: string;
  backgroundColor: string;
}

export type BankConsentTimelineStyleConfigMap = { [key in IrisTimelineEventType]: IrisTimelineStyleConfig };

export const BANK_CONSENT_TIMELINE_EVENT_STYLE_MAP: BankConsentTimelineStyleConfigMap = {
  [IrisTimelineEventType.CONSENT_REQUEST]: {
    backgroundColor: '#1976d2',
    icon: 'send',
  },
  [IrisTimelineEventType.CONSENT_CREATED]: {
    backgroundColor: '#23a800',
    icon: 'check_circle',
  },
  [IrisTimelineEventType.CONSENT_DEACTIVATED]: {
    backgroundColor: '#c9211e',
    icon: 'cancel',
  },
};

@Component({
  selector: 'itfg-bank-consent-timeline-event-icon',
  template: `
    <div class="event-dot" [style.background-color]="color">
      <mat-icon fontSet="material-symbols-outlined" class="event-icon">{{ icon }}</mat-icon>
    </div>
  `,
  styles: [`
    .event-dot {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }

    .event-icon {
      font-size: 14px;
      width: 14px;
      height: 14px;
      color: #fff;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BankConsentTimelineActivityEventComponent implements OnChanges {
  @Input() eventType: IrisTimelineEventType;

  icon: string;
  color: string;

  ngOnChanges(): void {
    const config = BANK_CONSENT_TIMELINE_EVENT_STYLE_MAP[this.eventType];
    if (config) {
      this.icon = config.icon;
      this.color = config.backgroundColor;
    } else {
      this.icon = 'info';
      this.color = '#757575';
    }
  }
}